<button mat-button (click)="closeModal()" color="warn" class="close-confirm-modal">
  <mat-icon>close</mat-icon>
</button>

<div class="container-confirm-toggle">
  <h3 class="title-confirmation">
    {{ (data.activate ? "model.patient.titleReactivation" : "model.patient.titleDeactivation") | translate }}
  </h3>

  <p>
    {{ (data.activate ? "model.patient.confirmReactivate" : "model.patient.confirmDeactivate") | translate }}
    <b>{{ data.currentUser?.firstname }} {{ data.currentUser?.name }}</b> ?
  </p>

  <div class="choice-container">
    <!-- Deactivation: Oui / Non -->
    <ng-container *ngIf="!data.activate">
      <button mat-raised-button (click)="confirm()" color="warn" class="choice-button" [disabled]="loading">
        {{ "model.patient.confirm" | translate }}
      </button>
      <button mat-raised-button (click)="closeModal()" color="primary" class="choice-button" [disabled]="loading">
        {{ "model.patient.cancel" | translate }}
      </button>
    </ng-container>

    <!-- Reactivation: Oui (conserver) / Oui (réinitialiser) / Non -->
    <ng-container *ngIf="data.activate">
      <button mat-raised-button (click)="confirm(false)" color="primary" class="choice-button" [disabled]="loading">
        {{ "model.patient.confirmKeepPassword" | translate }}
      </button>
      <button mat-raised-button (click)="confirm(true)" color="accent" class="choice-button" [disabled]="loading">
        {{ "model.patient.confirmResetPassword" | translate }}
      </button>
      <button mat-raised-button (click)="closeModal()" color="warn" class="choice-button" [disabled]="loading">
        {{ "model.patient.cancel" | translate }}
      </button>
    </ng-container>
  </div>

  <div *ngIf="loading" class="spinner-container">
    <mat-spinner diameter="30"></mat-spinner>
  </div>
</div>
